import { WorkbookNavItem } from '../⚛️atoms/WorkbookNavItem';
import { useRef, useState } from 'react';

export const WorkbookNavChapterGroup = ({ currentItem, currentChapter, section, onClick }) => {
  const [showDropdown, setShowDropdown] = useState(currentChapter === section);
  const chapterRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };
  return (
    <>
      <div className="relative top-0 left-3 w-full cursor-pointer bg-white">
        <div className="ml-3 flex w-full items-center">
          <WorkbookNavItem
            ref={chapterRef}
            title={section.title}
            subtitle={section.description}
            key={section?.id}
            onClick={toggleDropdown}
            completed={section.completed}
          />
        </div>
        {showDropdown && (
          <div className="joyride-nav-open sticky top-0 flex h-full flex-col">
            {section.items.map((item, index) => {
              return (
                <div className="relative ml-10 flex flex-col" key={index}>
                  <WorkbookNavItem
                    title=""
                    subtitle={item.title}
                    onClick={() => onClick(item)}
                    current={item._id === currentItem?._id}
                    shouldScrollTo={item?._id === currentItem?._id}
                    completed={item.item_id.completed}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
